import { Popover } from 'antd';
import React, { FC, ReactNode } from 'react';

type TProps = {
    children: ReactNode;
    isPopover?: boolean;
    content?: ReactNode;
};

export const WithPopover: FC<TProps> = ({ children, isPopover, content }) => {
    if (isPopover) {
        return <Popover content={content}>{children}</Popover>;
    }

    return <>{children}</>;
};
